<template>
  <div class="logistics">
    <div
      class="header acea-row row-between row-top"
      v-if="Object.keys(cartInfo).length > 0"
    >
      <div class="pictrue"><img :src="cartInfo.productInfo.image" /></div>
      <div class="text acea-row row-between">
        <div class="name line2">
          {{ cartInfo.productInfo.store_name }}
        </div>
        <div class="money">
          <div>￥{{ cartInfo.truePrice }}</div>
          <!--                    <div>x{{ cartInfo.cart_num }}</div>-->
        </div>
      </div>
    </div>
    <div class="logisticsCon">
      <div class="company acea-row row-between-wrapper">
        <div class="picTxt acea-row row-between-wrapper">
          <div class="iconfont icon-wuliu"></div>
          <div class="text">
            <div>
              <span class="name line1">物流公司：</span>
              {{ expressInfo.expName }}
            </div>
            <div class="express line1">
              <span class="name">快递单号：</span> {{ expressInfo.number }}
            </div>
          </div>
        </div>
        <div
          class="copy acea-row row-center-wrapper copy-data"
          :data-clipboard-text="expressInfo.number"
        >
          复制单号
        </div>
      </div>
      <div class="item" v-for="(express, index) in expressList" :key="index">
        <div class="circular" :class="index === 0 ? 'on' : ''"></div>
        <div class="text">
          <div :class="index === 0 ? 'font-color-red' : ''">
            {{ express.status }}
          </div>
          <div class="data">{{ express.time }}</div>
        </div>
      </div>
    </div>
    <div class="no-express" v-if="loaded && !expressList.length">
      <img src="@assets/images/noExpress.png" />
    </div>
  </div>
</template>
<script>
import ClipboardJS from "clipboard";
import { getExpressDetail, getReturnProductInfo } from "@api/user";

export default {
  name: "RefundLogisticDetail",
  data: function() {
    return {
      id: this.$route.params.id,
      type: this.$route.params.type,
      unique: this.$route.params.unique,
      oid: this.$route.params.oid,
      cartInfo: {},
      expressInfo: {},
      expressList: [],
      loaded: false
    };
  },
  mounted: function() {
    this.getExpress();
    this.getReturnProductInfo();
  },
  methods: {
    /**
     * 获取子订单信息
     */
    getReturnProductInfo() {
      let params = { oid: this.oid, unique: this.unique };
      getReturnProductInfo(params).then(res => {
        this.cartInfo = res.data.cart_info;
      });
    },
    /**
     * 获取快递信息
     */
    getExpress() {
      getExpressDetail({ id: this.id, type: this.type })
        .then(res => {
          const result = res.data.result || {};
          this.expressList = result.list || [];
          this.expressInfo = result;
          this.loaded = true;
          this.$nextTick(function() {
            var copybtn = document.getElementsByClassName("copy-data");
            const clipboard = new ClipboardJS(copybtn);
            clipboard.on("success", () => {
              this.$dialog.success("复制成功");
            });
          });
        })
        .catch(e => {
          this.$dialog.error(e.msg || "加载失败");
          setTimeout(() => {
            this.$router.go(-1);
          }, 1000);
        });
    }
  }
};
</script>

<style scoped>
.no-express {
  margin: 1.5rem 0;
}

.no-express img {
  width: 6rem;
  margin: 0 auto;
  display: block;
}
</style>
